var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},_vm._l((_vm.$GVAR.HotelStar.slice(2)),function(starItem,index){return _c('span',{key:index,staticClass:"star-item h7",on:{"click":function($event){return _vm.$emit('setStar',starItem)}}},[_vm._v(_vm._s(starItem.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }